import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from '../../translations';
import PropTypes from 'prop-types';
import PulseButton from 'components/PulseButton';
import AdvBtn from 'icons/NextArrow.svg';
import { flashForwardButton } from 'store/actions/ui';
import InactivityManager from 'utils/InactivityManager';

import styles from './ForwardButton.module.scss';

const inactivityTime = 1000 * 5;
const blueArrowTime = 1000 * 10;
const REASON = { didNotMoveToNextRound: 'Did not press the blue button' };

export class ForwardButton extends Component {
  constructor(props) {
    super(props);
    this.state = { loaded: false, pulse: false };
    this.inactivityManager = new InactivityManager();
    this.instructionsPlayedCount = 0;
  }

  pulseButton = () =>
    this.setState({
      pulse: true
    });

  clearPulse = () => {
    this.setState({
      pulse: false
    });
  };

  handleButtonClick = () => {
    const {
      props: { activityDone, onClick, flashForwardButton }
    } = this;

    if (activityDone) onClick();
    else flashForwardButton();
  };

  playTouchTheBlueArrow = () => {
    this.props.touchBlueArrow && this.props.touchBlueArrow.play();
    this.pulseButton();
    this.instructionsPlayedCount += 1;
    // this.inactivityManager.clear();
    if (this.instructionsPlayedCount < 2) {
      // we'll be playing only twice the blue arrow instructions
      this.inactivityManager.watch(
        blueArrowTime,
        () => this.playTouchTheBlueArrow(),
        REASON.didNotMoveToNextRound,
        true
      );
    }
  };

  handleInactivity = () => {
    this.inactivityManager.clear();
    this.pulseButton();
    this.inactivityManager.watch(
      blueArrowTime,
      () => this.playTouchTheBlueArrow(),
      REASON.didNotMoveToNextRound,
      true
    );
  };

  componentDidMount() {
    if (this.props.activityDone) {
      this.inactivityManager.watch(
        inactivityTime,
        this.handleInactivity,
        REASON.didNotMoveToNextRound,
        true
      );
    }
  }

  componentWillUnmount() {
    this.props.touchBlueArrow && this.props.touchBlueArrow.stop();
    this.inactivityManager.clear();
  }

  componentDidUpdate(prevProps) {
    const {
      props: { activityDone, pulseTimeStamp }
    } = this;

    const { activityDone: prevDone, pulseTimeStamp: prevStamp } = prevProps;

    if (pulseTimeStamp && pulseTimeStamp !== prevStamp) {
      this.pulseButton();
    }

    if (activityDone && activityDone !== prevDone) {
      this.inactivityManager.watch(inactivityTime, () => this.handleInactivity());
    }
  }

  render() {
    const {
      props: { contentScaling },
      state: { loaded, pulse },
      clearPulse,
      handleButtonClick
    } = this;

    return (
      <PulseButton
        pulse={pulse}
        loaded={loaded}
        className={[styles.ForwardButton, styles[`ForwardButton${contentScaling}`]].join(' ')}
        src={AdvBtn}
        onClick={() => handleButtonClick()}
        onLoaded={() => this.setState({ loaded: true })}
        clearPulse={() => clearPulse()}
        label={t('BlueForwardArrow')}
      />
    );
  }
}

ForwardButton.propTypes = {
  onClick: PropTypes.func,
  flashForwardButton: PropTypes.func,
  pulseTimeStamp: PropTypes.number,
  activityDone: PropTypes.bool,
  touchBlueArrow: PropTypes.object,
  contentScaling: PropTypes.number
};

const mapStateToProps = state => ({
  pulseTimeStamp: state.ui.forwardButton.pulseTimeStamp,
  activityDone: state.ui.forwardButton.isDone,
  touchBlueArrow: state.ui.sounds.common.touchTheBlueArrow
});

export default connect(mapStateToProps, { flashForwardButton })(ForwardButton);
